import Model from './Model'

export default class OldWoononOrderModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'old/orders'
  }
}
